import { Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { DadosPessoaisAba1Response } from 'app/auth/_models/DadosPessoaisAba1';
import { DependentesServidorDto } from '../recadastramento-aba7/dependentesServidor.dto';
import { ToastrService } from 'ngx-toastr';
import {
  DependentesServidorAba11Service
} from "../../service/dados-plano-dependente-aba11/dados-plano-dependente-aba11.service";
import { Observable, Subscription } from 'rxjs';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatOption } from '@angular/material/core';
import { saveAs } from 'file-saver';
import { PlanoDeSaudeServidorDto } from '../recadastramento-aba10/plano-de-saude-servidor.dto';
import { ConcessaoAuxDto } from '../recadastramento-aba10/concessaoAux.dto';
import { Enum } from 'app/model/enum';
import { CampanhasService } from "../../service/campanhas/campanhas.service";

const ELEMENT_DATA: ConcessaoAuxDto[] = [];


@Component({
  selector: 'app-recadastramento-aba11',
  templateUrl: './recadastramento-aba11.component.html',
  styleUrls: ['./recadastramento-aba11.component.sass']
})
export class RecadastramentoAba11Component implements OnInit {

  @Input() dadosPessoaisUser: any;
  @Input() mostrarAlerta: any;
  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();
  @Output() dadosSalvos: EventEmitter<void> = new EventEmitter<void>();
  @Output() formularioSalvo = new EventEmitter<void>();
  @ViewChild(MatTable) table: MatTable<any>;
  @ViewChildren('select') selects: QueryList<MatSelect>;
  @ViewChild('fileInputComprovante') fileInputComprovante!: ElementRef;
  @ViewChildren('fileInputComprovante') fileInputComprovanteList!: QueryList<ElementRef>;
  fileInputComprovanteElements: { [key: number]: ElementRef } = {};
  formAuxilioDependentes: FormGroup;
  formAuxilioDependente: FormGroup;
  formDependentes: FormGroup;
  formDependente: FormGroup;
  user: DadosPessoaisAba1Response = null;
  private formListSubscription: Subscription;
  nome: string;
  codigo: number;

  isLoading: boolean = true;
  isInfoImportantVisible: boolean = true;
  isLoadingSpinner: boolean = false

  auxilioDependentes: DependentesServidorDto[];
  planosDependente: PlanoDeSaudeServidorDto[];

  nomeDependente = ' Maria Silva dos Santos';
  nomeDependente2 = 'Antonio Silva dos Santos'

  planos = new FormControl('');
  planoList: string[] = ['SulAmérica', 'Amil', 'Unimed', 'Bradesco', 'Hapvida', 'Cassis'];
  dataSource = ELEMENT_DATA;
  existDiff: Boolean = false;

  meses: any[] = [];
  meslist: any[];
  selectedMonthIndex: number;
  displayedColumns: string[] = ['data', 'mensalidade', 'valorPago', 'acoes'];

  //dataSources = ELEMENT_DATA;
  dataSources = new MatTableDataSource<any>([]);
  concessoesServidor: any[];
  contDependente: number;
  panelOpenState = false;
  dependentes: any[];
  tipoParentescos: any[];
  selectedMonths: number[] = [];
  mesesSelecionados: number[];
  arquivoSelecionado: File;
  mesesForm: FormControl = new FormControl();
  flTodos: boolean = false
  existDependentes: boolean = false
  markTodos: boolean = false
  isLoadingFile: boolean = false;
  temMesesNaoPagos: boolean;
  tamanhoListaDependentes: number;
  tituloCampanhaRecadVigente: string;

  constructor(
    private toasterService: ToastrService,
    private formBuilder: FormBuilder,
    private dependentesServidorAba11Service: DependentesServidorAba11Service,
    private campanhasService: CampanhasService

  ) {
    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));
    this.selectedMonthIndex = null;
  }

  ngOnInit(): void {

    this.formAuxilioDependentes = this.formBuilder.group({
      dependentes: this.formBuilder.array([])
    });
    // this.formListSubscription = this.formList.valueChanges.subscribe(() => {
    //   this.updateDataSource();
    // });
    this.carregarDadosIniciais()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.mostrarAlerta) {
      this.isInfoImportantVisible = true
    }
  }

  checkDiffPlano(event: MatSelectChange, index, numeroDependente) {
    this.getDependentesFormObject()['at'](index).get('codigo').setValue(event.value)

    this.getConcessoes(event.value, numeroDependente, index);
  }

  checkDiffMesesNaoPagos(index) {
    const mesesNaoPagos = this.getDependentesFormObject()['at'](index).get('existMesesNaoPagos').value;
    const dependentesValoresPagosNull = this.getDependentesFormObject()['at'](index).get('mesesNaoPagos').value.length > 0;

    if (mesesNaoPagos.length > 0 || dependentesValoresPagosNull) {
      this.getDependentesFormObject()['at'](index).get('existDiffMesesNaoPagos').setValue(true);
      return true;
    } else {
      this.getDependentesFormObject()['at'](index).get('existDiffMesesNaoPagos').setValue(false);
      return false;
    }
  }

  private getConcessoes(codigoPlano: number, numeroDependente: number, index: number) {

    this.dependentesServidorAba11Service.getMesesPlanoDependentes(codigoPlano, numeroDependente).subscribe(resp => {


      this.getDependentesFormObject()['at'](index).get('mesesNaoPagos').setValue([])
      // this.markTodos = false
      //this.getDependentesFormObject()['at'](index).get('mesesPagos').setValue(resp),
      this.concessoesServidor = resp;
      this.existDependentes = false

      this.montarComboDatas(index);
      this.mesesNaoPagos(index)
    });
  }

  ngOnDestroy() {
    // Certifique-se de cancelar a inscrição no ngOnDestroy para evitar vazamentos de memória
    if (this.formListSubscription) {
      this.formListSubscription.unsubscribe();
    }
  }
  carregarDadosIniciais() {
    this.getDependentes();
    this.campanhasService.getCampanhaRecadVigente().subscribe( resp => {
      this.tituloCampanhaRecadVigente = resp.nome;
    })
  }
  buildForm(): FormGroup {
    return this.formBuilder.group({
      // Defina aqui os controles do formulário
      dependente: [''],
      nome: [''],
      numeroDependente: [''],
      codigo: [''],
      parentesco: [''],
      meses: [[]],
      mesesRespPlano: [[]],
      mesesPagos: [[]],
      mesesNaoPagos: [[]],
      existMesesNaoPagos: [[]],
      existDiffNome: [],
      existDiffMesesNaoPagos: [],
      valorPago: [''],
      markTodos: [''],
      temPlano: [''],
      isDisableValorPago: [true],
      habilitarAnexo: [''],
      planosDependente: [[]]
      // ... outros controles
    });


  }

  private montarComboDatas(index: number) {

    this.clearDataSource(index)
    //this.getDependentesFormObject()['at'](index).get('valorPago').disable()
    this.getDependentesFormObject()['at'](index).get('habilitarAnexo').setValue(true);

    this.concessoesServidor.forEach(n => {
      if (n.valorPago == 0 || n.valorPago == '0' || n.valorPago === null) {
        const mesesNaoPagosControl = this.getDependentesFormObject()['at'](index).get('mesesNaoPagos');

        const mesesNaoPagosArray = mesesNaoPagosControl.value || [];
        mesesNaoPagosArray.push(n);
        mesesNaoPagosControl.setValue(mesesNaoPagosArray);
      } else {
        this.getDependentesFormObject()['at'](index).get('mesesPagos').setValue(n)
        this.updateDataSource(n, index);
      }
    });
  }

  private getDependentes() {
    this.dependentesServidorAba11Service.getDependentes().subscribe(resp => {
      if (resp.length > 0) {
        this.dependentes = resp;

        const formDependentes: FormGroup[] = [];
        for (let dep of resp) {
          const formDependente: FormGroup = this.buildForm();
          formDependente.patchValue(dep);

          formDependente.get('existDiffNome').patchValue(dep.dependente ? true : false);
          //formDependente.get('existDiffMesesNaoPagos').patchValue(dep.mesesNaoPagos ? true : false);
          formDependentes.push(formDependente);
        }
        // Limpe todos os controles existentes no formList
        this.formList.clear();
        this.tamanhoListaDependentes = formDependentes.length
        for (let i = 0; i < formDependentes.length; i++) {
          const formDependente = formDependentes[i];
          const existentDependente = this.formList.getRawValue().find(item => item.numeroDependente === formDependente.value.numeroDependente);
          if (!existentDependente) {
            const formDependenteValue = formDependente;
            const codigo = formDependente.value.codigo;
            const nome = formDependente.value.nome;
            formDependenteValue.value.planosDependente.push({ codigo, nome });
            this.formList.push(formDependenteValue);
          } else {
            const formDependenteNumero = formDependente.value.numeroDependente;
            const formEncontrado = this.formList.getRawValue().find(form => form.numeroDependente === formDependenteNumero);

            if (formEncontrado) {
              // Adicione o código e o nome de formDependente ao atributo planosDependente do formulário encontrado
              const codigo = formDependente.value.codigo;
              const nome = formDependente.value.nome;

              formEncontrado.planosDependente.push({ codigo, nome });

            }
          }
        }
        this.formList.getRawValue().forEach((d, index) => {
          this.getConcessoes(d.planosDependente[0].codigo, d.numeroDependente, index);
        });
      } else {
        this.existDependentes = true
      }

    });
  }


  getDependentesFormObject() {
    return this.formAuxilioDependentes.get('dependentes')
  }

  private updateDataSource(n: any, index: number) {
    // Obtenha o dataSource existente
    const existingData = this.dataSources[index]?.data || [];

    // Crie um novo objeto com os valores a serem adicionados
    const newData = {
      data: n.data,
      mensalidade: n.mensalidade,
      mes: n.mes,
      valorPago: n.valorPago
    };

    // Adicione o novo objeto aos dados existentes
    const updatedData = [...existingData, newData];

    // Crie uma nova instância de MatTableDataSource com os dados atualizados
    const dataSource = new MatTableDataSource<any>(updatedData);

    // Atualize o dataSource correspondente
    this.dataSources[index] = dataSource;
  }

  extistDiff(index) {
    this.existDiff = true;
    this.getDependentesFormObject()['at'](index).get('habilitarAnexo').setValue(false);

  }

  excluirItemTable(element, index) {
    const mes = element.mes;

    const codigoPlano = this.getDependentesFormObject()['at'](index).get('codigo').value;
    const numeroDependente = this.getDependentesFormObject()['at'](index).get('numeroDependente').value;
    this.toasterService.info('Deletando registro.');
    this.dependentesServidorAba11Service.deletarComprovante(codigoPlano, numeroDependente, mes).subscribe(
      resp => {
        this.dataSource = this.dataSource.filter(row => element !== row);
        this.dataSources[index].filteredData = this.dataSources[index].filteredData.filter(data => data.mes !== mes);
        this.dataSources[index].data = this.dataSources[index].filteredData;

        const mesesNaoPagosControl = this.getDependentesFormObject()['at'](index).get('mesesNaoPagos');
        const mesesNaoPagosArray = mesesNaoPagosControl.value || [];
        const hasMonth = mesesNaoPagosArray.some(item => item.mes === mes);

        if (!hasMonth) {
          mesesNaoPagosArray.push(element);
          mesesNaoPagosArray.sort((a, b) => a.mes - b.mes);
          mesesNaoPagosControl.setValue(mesesNaoPagosArray);
        }
        this.toasterService.success('Registro deletado.');
      },
      error => {
        this.toasterService.error('Erro ao deletar.');
      }
    );
  }
  ngAfterViewChecked() {
    this.fileInputComprovanteList.toArray().forEach((element) => {
      const itemId = parseInt(element.nativeElement.id.split('-')[3]);
      this.fileInputComprovanteElements[itemId] = element;
    });
  }


  limparArquivo(itemID: number) {
    const fileInputComprovante = this.fileInputComprovanteElements[itemID];

    if (fileInputComprovante) {
      fileInputComprovante.nativeElement.value = '';
    }
  }


  limparSelecoes(index) {
    this.selects['_results'][index].options.forEach((item) => {
      item.deselect();
    });
  }
  onSelectMonth(selectedIndices: number[], index: number) {
    //this.getDependentesFormObject()['at'](index).get('valorPago').enable()
    this.getDependentesFormObject()['at'](index).get('isDisableValorPago').setValue(false)

    this.mesesSelecionados = selectedIndices['value'].filter(value => value !== 0);

    const selected = selectedIndices['value'];
    if (selected.includes(0)) {
      this.selects['_results'][index].options.forEach((item) => {
        this.flTodos = true
        item.select();
      });
      const tamanhoMeses = this.getDependentesFormObject()['at'](index).get('meses').value

      if (tamanhoMeses.length < 13) {
        this.markTodos = false;
        this.flTodos = false
      }
      else {
        this.flTodos = true;
      }
      this.markTodos = true;
      this.getDependentesFormObject()['at'](index).get('markTodos').setValue(true);
    } else {
      // this.getDependentesFormObject()['at'](index).get('mesesNaoPagos').length < 1 ? this.getDependentesFormObject()['at'](index).get('valorPago').disable() : this.getDependentesFormObject()['at'](index).get('valorPago').enable()
      //this.getDependentesFormObject()['at'](index).get('markTodos').setValue(false);
      this.flTodos = false
      if (this.markTodos) {
        this.markTodos = false;
        this.getDependentesFormObject()['at'](index).get('markTodos').setValue(false);
        this.selects['_results'][index].options.forEach((item) => {
          this.getDependentesFormObject()['at'](index).get('meses').patchValue([]);
        });
        //this.getDependentesFormObject()['at'](index).get('valorPago').disable()
      }
    }
  }


  onArquivoSelecionado(event: any, index: number) {
    const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    const maxFileSizeInBytes = 1024 * 1024 * 10; // 10 MB
    const file = event.target.files[0];
    const input = document.getElementById('input-file-comprovante') as HTMLInputElement;
    if (file && allowedFileTypes.includes(file.type) && file.size <= maxFileSizeInBytes) {
      this.isLoadingFile = true;
      this.arquivoSelecionado = file;
      this.atualizarDependente(index);
    }
    else {
      this.arquivoSelecionado = null;
      this.limparArquivo(index);
      if (!allowedFileTypes.includes(file.type)) {
        this.toasterService.warning('Tipo de arquivo inválido! Apenas arquivos JPG, JPEG, PNG e PDF são permitidos.');
        input.value = '';
      } else if (file.size > maxFileSizeInBytes) {
        this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
        input.value = '';
      }
    }
    input.value = '';
  }

  getArquivo(index: number, mes: number, data: string): void {
    const numeroDependente = this.getDependentesFormObject()['at'](index).get('numeroDependente').value
    const codigoPlano = this.getDependentesFormObject()['at'](index).get('codigo').value
    this.dependentesServidorAba11Service.visualizarComprovanteMes(codigoPlano, numeroDependente, mes).subscribe((response: Blob) => {
      const fileType = response.type || 'application/octet-stream'; // Tipo

      let fileName = 'Comprovante_Plano_Dependente_' + data;
      const fileExtension = this.getFileExtensionFromMimeType(fileType);

      if (fileExtension) {
        fileName += '.' + fileExtension;
      }

      const blob = new Blob([response], { type: fileType });
      // Inicia o download do arquivo
      this.downloadFile(blob, fileName);
    }, error => {
      this.toasterService.warning('Erro ao fazer o download do arquivo.', '', {
        timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      });
    });
  }
  downloadFile(blob: Blob, fileName: string): void {
    saveAs(blob, fileName);
    this.toasterService.success('Arquivo baixado com sucesso.', '', {
      timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
    });

  }

  private getFileExtensionFromMimeType(mimeType: string): string | null {
    const extensionMap = {
      'application/pdf': 'pdf',
      'image/jpeg': 'jpeg',
      'image/jpg': 'jpg',
      'image/png': 'png'
      // Adicione outras extensões e tipos MIME conforme necessário
    };

    return extensionMap[mimeType] || null;
  }

  onArquivoExcluidoComprovante(index: number, mes: number) {
    const numeroDependente = this.getDependentesFormObject()['at'](index).get('numeroDependente').value
    const input = document.getElementById('input-file-comprovante') as HTMLInputElement;
    const codigoPlano = this.getDependentesFormObject()['at'](index).get('codigo').value
    this.dependentesServidorAba11Service.deletarComprovante(codigoPlano, numeroDependente, mes).subscribe(resp => {

      this.toasterService.success('Arquivo excluído com sucesso.', '', {
        timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      });
      this.arquivoSelecionado = null;
      input.value = '';
    }, error => {
      this.toasterService.error('Erro ao excluir comprovante.', '', {
        timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      });
    });

  }
  private clearDataSource(index: number) {
    const dataSource = new MatTableDataSource<any>([]);
    this.dataSources[index] = dataSource;
  }

  atualizarDependente(index) {
    let numeroDoDependente = (this.getDependentesFormObject()['at'](index).get('numeroDependente').value)
    const valorPago = this.getDependentesFormObject()['at'](index).get('valorPago').value
    const codigoPlano = this.getDependentesFormObject()['at'](index).get('codigo').value
    const nome = this.getDependentesFormObject()['at'](index).get('dependente').value

    if (this.arquivoSelecionado) {

      this.toasterService.info('Enviando arquivo. Por favor, aguarde.', '', {
        timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      });
      this.dependentesServidorAba11Service.enviarComprovanteEMes(this.arquivoSelecionado, this.mesesSelecionados, this.flTodos, numeroDoDependente, nome, valorPago, codigoPlano).subscribe(
        (response) => {
          this.limparArquivo(index);
          // this.getDocumentosPessoias();
          this.isLoadingFile = false;
          this.toasterService.success('Dependente atualizado com sucesso.', '', {
            timeOut: 1500, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
          });
          this.getDependentesFormObject()['at'](index).get('valorPago').reset()
          this.clearDataSource(index)
          this.montarComboDatas(index)
          this.getConcessoes(codigoPlano, numeroDoDependente, index)


        },
        (error) => {
          this.toasterService.error(`Erro ao enviar anexo(s): ${error.error.message}`, '', {
            timeOut: 1500, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
          });
          this.limparArquivo(index);
          this.isLoadingFile = false;
          this.getDependentesFormObject()['at'](index).get('habilitarAnexo').setValue(false);
        }
      );
    }
  }

  getMesesPlanoDependente(plano: number, numeroDependente: number): Observable<any> {
    return this.dependentesServidorAba11Service.getMesesPlanoDependentes(plano, numeroDependente);
  }

  get formList() {
    return this.formAuxilioDependentes.controls["dependentes"] as FormArray;
  }

  toggleInfoImportantVisible() {
    this.isInfoImportantVisible = !this.isInfoImportantVisible;
  }

  private async getConcessoesMesesNaoPagos(codigoPlano: Enum[], numeroDependente: number, index: number) {
    const codigo = codigoPlano['codigo'];

    try {
      const resp = await this.dependentesServidorAba11Service.getMesesPlanoDependentes(codigo, numeroDependente).toPromise();
      this.concessoesServidor = resp;
      console.log(resp)
      //this.getDependentesFormObject()['at'](index).get('mesesRespPlano').setValue(resp);
      this.existDependentes = false;
      this.mesesNaoPagos(index);
    } catch (error) {
      console.error('Erro na solicitação HTTP:', error);
    }
  }

  private mesesNaoPagos(index: number) {
    const mesesNaoPagos = [];
    const mesesPagos = [];

    this.concessoesServidor.forEach(n => {
      if (Number(n.valorPago) === 0 || n.valorPago === null || n.valorPago === '0') {
        mesesNaoPagos.push(n);


      } else {
        mesesPagos.push(n);
      }
    });

    this.getDependentesFormObject()['at'](index).get('existMesesNaoPagos').setValue(mesesNaoPagos);
    this.getDependentesFormObject()['at'](index).get('mesesPagos').setValue(mesesPagos);

    if (mesesNaoPagos.length > 0) {
      this.temMesesNaoPagos = true;
      //this.toasterService.error('Por favor, preencha os valores pagos de todos os meses.');
      return;
    } else {
      this.temMesesNaoPagos = false;
    }
  }


  async avancaParaProximoTab() {
    const dependentes = this.formAuxilioDependentes.getRawValue().dependentes;
    let todosValoresPagosNull = true; // Verifica se todos os valores pagos são nulos

    if (dependentes.length === 0) {
      this.toasterService.success('Dados atualizados com sucesso!', '', {
        timeOut: 2000,
      });
      this.dadosSalvos.emit();
    } else {
      for (let index = 0; index < dependentes.length; index++) {
        const dependente = dependentes[index];
        const planosDependente = dependente.planosDependente;

        // Resetar a flag para cada dependente
        let dependentesValoresPagosNull = true;

        for (const plano of planosDependente) {
          // Chamada para obter informações
          await this.getConcessoesMesesNaoPagos(plano, dependente.numeroDependente, index);

          // Verificar se há algum valorPago igual a 0 nas concessõesServidor
          if (this.concessoesServidor.some(n => Number(n.valorPago) === 0 || n.valorPago === null || n.valorPago === '0')) {
            dependentesValoresPagosNull = false;
            break; // Se um valor igual a 0 for encontrado, podemos sair do loop
          }
        }

        if (!dependentesValoresPagosNull) {
          todosValoresPagosNull = false;
          break; // Se um dependente tiver valores iguais a 0, não precisamos continuar verificando outros dependentes
        }
      }

      if (todosValoresPagosNull) {
        this.toasterService.success('Dados atualizados com sucesso!', '', {
          timeOut: 2000,
        });
        this.dadosSalvos.emit();
      } else {
        this.toasterService.error('Por favor, preencha os valores pagos de todos os meses.', '', {
          timeOut: 2000,
        });
      }
    }
  }



  voltarPaginaAnterior() {
    this.voltarPagina.emit()
  }

}
